<template>
	<div class="contact-container">
		<div class="contact-container-overflow">
			<form class="contact-form" @submit.prevent="addVehicle">
				<div class="sp-3 flex ai-c jc-sb">
					<h4>Informações do Veículo</h4>
					<p style="margin-bottom: 0">Os campos marcados com <span class="tx-danger">*</span> são obrigatórios.</p>
				</div>
				<div>
					<v-input
						name="name"
						type="text"
						label="Nome do Veículo"
						v-model="vehicle.name"
						:requiredFlag="true"
						:class="{'input-danger': getError('name') }"
					/>
					<div class="field-error">
						{{ getError('name') }}
					</div>
				</div>
				<div>
					<select-wrapper v-model="vehicle.type" :options="typeOptions" label="Tipo" :requiredFlag="true" :class="{'input-danger': getError('type') }"/>
					<div class="field-error">
						{{ getError('type') }}
					</div>
				</div>
				<div></div>
				<div>
					<v-input name="imo" type="text" label="IMO" v-model="vehicle.imo"/>
				</div>
				<div>
					<v-input name="mmsi" type="text" label="MMSI" v-model="vehicle.mmsi"/>
				</div>
				<div>
					<v-input name="flag" type="text" label="Bandeira" v-model="vehicle.flag"/>
				</div>
				<div class="sp-3 row justify-content-center mt-4 gap-2">
					<button type="button" class="crm-button red mr-4" @click="$emit('cancel')">Cancelar</button>
					<button type="submit" class="report-button">Salvar</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import * as yup from "yup";
import config from "@/config.js";
import Axios from "axios";
import Swal from "sweetalert2";
import SelectWrapper from "@/components/SelectWrapper.vue";
import VInput from "@/components/VInput.vue";

export default {
	name: "AddVehicle",
	components: {
		SelectWrapper,
		VInput,
	},
	props: {
		data: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			fieldErrors: [],
			vehicle: { ...this.data },
			typeOptions: [
				{
					label: "Navio",
					value: "VESSEL",
				},
				{
					label: "Avião",
					value: "AIRCRAFT",
				},
				{
					label: "Caminhão",
					value: "TRUCK",
				},
			]
		};
	},
	computed: {},
	mounted() {},
	methods: {
		getError(path) {
			const err = this.fieldErrors.find((e) => e.path === path);
			if (err) {
				return err.message;
			}
			return '';	
		},
		async addVehicle() {
			this.fieldErrors = [];
			try {

				let schema = yup.object().shape({
					name: yup.string().required('O Nome do Veículo é obrigatório'),
					type: yup.string().required('O Tipo é obrigatório'),
				});

				await schema.validate(this.vehicle, {
					abortEarly: false,
				});

				let request = {
					name: this.vehicle.name,
					type: this.vehicle.type,
					imo: this.vehicle.imo,
					mmsi: this.vehicle.mmsi,
					flag: this.vehicle.flag,
				};

				const response = await Axios.post(`${config.env.API_DEFAULT.host}/vehicles`, request);

				let newVehicle = {
					...response.data.data,
					entity: this.vehicle.entity,
					_links: {
						self: {
							href: `${config.env.API_DEFAULT.host}/vehicles/${response.data.data.id}`,
						},
					},
				};
				this.$emit('finish', newVehicle);
			} catch (error) {
				if (error.name == "ValidationError") {
					this.fieldErrors = error.inner;
					console.log(this.fieldErrors);
					let html = '<div class="text-left pl-4 pr-4 pt-4"><p>Por favor, preencha os campos obrigatórios abaixo!</p>';
					if (error.errors.length > 0) {
						html += '<ul>';
						error.errors.forEach(error => {
							html += `<li class="mb-2">${error}</li>`
						})
						html += '</ul>';
					}
					html += '</div>';
				
					Swal.fire({
						title: 'Adicionar Veículo',
						html: html,
						type: 'error',
						customClass: 'alert-error'
					});
				} else {
					let message = error.response.data?.data || error.response.data?.message;
					if (!message) {
						message = 'Não foi possível adicionar o veículo';
					}
					Swal.fire({
						title: "Adicionar Veículo",
						html: `<p>${message}</p>`,
						type: "error",
					});
				}
			}
		},
	},
};
</script>

<style scoped>
.report-button {
  --webkit-appearance: none;
  --moz-appearance: none;
  outline: none;
  --webkit-outline: none;
  --moz-outline: none;
  border: 0;
  background-color: #104375;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  border-radius: 2px;
  color: white;
  padding: 10px 35px;
  border-radius: 10px;
  text-transform: uppercase;
  transition: all 0.2s ease-in-out 0s;
  font-size: 1rem;
}

.report-button:hover {
  background-color: #1768a7;
}
.contact-container {
	height: auto !important;
}
</style>

<style>
.alert-error {
	width: 500px !important;
}
</style>